import { h, Host } from "@stencil/core";
export class RadioButtonMediaGroup {
    onValueChange(e) {
        this.setCssCLasses(e);
    }
    setCssCLasses = (e) => {
        const radioButtons = document.querySelectorAll(`.ux-radio-button-media-group input[type=radio][name=${e.detail.name}]`);
        if (radioButtons) {
            radioButtons.forEach(function (el) {
                const uxElement = el.closest(".ux-radio-button-field");
                if (uxElement) {
                    if (e.detail.value === el.value) {
                        uxElement.classList.add("ux-radio-button-field--active");
                    }
                    else {
                        uxElement.classList.remove("ux-radio-button-field--active");
                    }
                }
            });
        }
    };
    render() {
        const baseClass = "ux-radio-button-media-group";
        return (h(Host, { key: '1ab077458f9ee92bde5b17546681c06c5b625099', class: {
                [baseClass]: true
            } }, h("slot", { key: 'eddc9bc5254fae8b5deb4cfb9aa06f8c4529e906' })));
    }
    static get is() { return "ux-radio-button-media-group"; }
    static get originalStyleUrls() {
        return {
            "$": ["radio-button-media-group.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["radio-button-media-group.css"]
        };
    }
    static get listeners() {
        return [{
                "name": "uxRadioButtonChange",
                "method": "onValueChange",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=radio-button-media-group.js.map
